import {
  lighten,
  transparentize,
} from '@nobia/zeus-components/lib/helpers/polished'
import rem from '@nobia/zeus-components/lib/styled/rem'
import { getTheme } from '@nobia/zeus-components/lib/themes'

const primaryColor = '#111111'
const secondaryColor = '#D6D6D6'
const white = '#fff'

const tone1 = '#F7EFE9'
const tone2 = '#FAF5F2'
const tone3 = '#F2F2F2'

const textColor = '#111111'
const error = '#E2001A'

const red = '#E2001A'
const lineColor = '#D6D6D6'

const theme = getTheme('hthdk')

export default {
  colors: { textColor: primaryColor, tone1, error, secondary: primaryColor },
  header: {
    wrapper: {
      background: '#ffffff',
      md: {
        height: theme.rem(100),
      },
    },
    title: {
      fontWeight: 300,
      fontSize: 23,
      lineHeight: 23,
    },
    logo: {
      marginLeft: '28px',
      margin: '24px 0 10px',
      width: theme.rem(75),
      md: {
        width: theme.rem(75),
      },
    },
  },
  home: {
    border: `1px solid #eaeaea`,
    image: {
      borderRadius: 0,
    },
  },
  close: {
    background: primaryColor,
  },
  navigation: {
    wrapper: {
      background: '#fff',
      border: `1px solid ${transparentize(0.8, '#979797')}`,
      padding: `${theme.rem(7)} 0`,
      lg: {
        padding: `${theme.rem(17)} ${theme.rem(19)}`,
      },
    },
    item: {
      color: textColor,
      activeColor: textColor,
      activeBackgroundColor: tone3,
      borderRadius: 6,
      fontWeight: 400,
      fontSize: 12,
      lg: {
        fontSize: 15,
      },
    },
  },
  tabs: {
    background: tone2,
    color: textColor,
    backgroundColor: '#f0e8db',
    activeColor: textColor,
    activeBackgroundColor: theme.colors.white,
  },
  buttons: {
    textTransform: 'uppercase',
    borderRadius: 26,
    fontWeight: 700,
    lineHeight: 22,
    letterSpacing: 1.5,
    padding: {
      small: `${theme.rem(6)}`,
      default: `${theme.rem(12)} ${theme.rem(30)} ${theme.rem(14)}`,
      large: `${theme.rem(21)} ${theme.rem(42)} ${theme.rem(20)}`,
    },
    fontSize: {
      small: 11,
      default: 12,
      large: 16,
    },
    primary: {
      color: white,
      background: primaryColor,
      activeBackground: transparentize(0.15, primaryColor),
    },
    outlined: {
      color: white,
      background: primaryColor,
      activeBackground: transparentize(0.15, primaryColor),
    },
    secondary: {
      color: white,
      background: secondaryColor,
      activeBackground: lighten(0.15, secondaryColor),
    },
    disabled: {
      color: white,
      background: lighten(0.75, primaryColor),
    },
  },
  modal: {
    background: '#fff',
  },
  forms: {
    background: '#fff',
    borderRadius: '26px',
    padding: '13px 20px',
    height: rem(50),
    fontSize: rem(14),
    fontFamily: '"Clan", "Georgia", serif',
    fontWeight: 300,
    colors: {
      border: '#e9e1d9',
      selected: primaryColor,
      errorBackground: '#f0e8db',
      errorColor: textColor,
    },
  },
  typography: {
    heading1: {
      fontFamily: 'Clan',
      fontSize: 30,
      lineHeight: 38,
      fontWeight: 700,
      color: textColor,
      textTransform: 'none',
      md: {
        fontSize: 42,
        lineHeight: 48,
      },
    },
    heading2: {
      fontFamily: 'Clan',
      fontSize: 22,
      lineHeight: 28,
      fontWeight: 700,
      color: textColor,
      md: {
        fontSize: 32,
        lineHeight: 38,
      },
    },
    heading3: {
      fontFamily: 'Clan',
      fontSize: 20,
      lineHeight: 26,
      fontWeight: 700,
      color: textColor,
      md: {
        fontSize: 26,
        lineHeight: 34,
      },
    },
    heading4: {
      fontFamily: 'Clan',
      fontSize: 18,
      lineHeight: 26,
      fontWeight: 700,
      color: textColor,
      md: {
        fontSize: 18,
        lineHeight: 26,
      },
    },
    heading5: {
      fontFamily: 'Clan',
      fontSize: 16,
      lineHeight: 22,
      fontWeight: 700,
      color: textColor,
      md: {
        fontSize: 16,
        lineHeight: 22,
      },
    },
    heading6: {
      fontFamily: 'Clan',
      fontSize: 15,
      lineHeight: 22,
      fontWeight: 700,
      color: textColor,
      md: {
        fontSize: 15,
      },
    },
    preamble: {
      fontFamily: 'Clan',
      fontWeight: 300,
      fontSize: 21,
      lineHeight: 33,
      md: {
        fontSize: 26,
        lineHeight: 40,
      },
    },
    preambleB: {
      fontFamily: 'Clan',
      fontWeight: 300,
      fontSize: 18,
      lineHeight: 28,
      md: {
        fontSize: 21,
        lineHeight: 31,
      },
    },
    paragraphLead: {
      fontWeight: 300,
      fontSize: 18,
      lineHeight: 26,
    },
    paragraph: {
      fontWeight: 300,
      fontSize: 16,
      lineHeight: 24,
      color: textColor,
      fontFamily: 'Clan',
    },
    paragraphSmall: {
      fontWeight: 300,
      fontSize: 13,
      lineHeight: 18,
      color: textColor,
      md: {
        fontSize: 14,
        lineHeight: 19,
      },
    },
    paragraphByline: {
      fontWeight: 300,
      fontSize: 13,
      lineHeight: 18,
      color: '#7f8487',
      md: {
        fontSize: '14px',
        lineHeight: '19px',
      },
    },
    link: {
      fontWeight: 300,
      color: primaryColor,
    },
    input: {
      fontSize: 16,
    },
  },
  saved: {
    image: {
      borderRadius: rem(0),
      boxShadow: 'none',
      largeProducts: {
        width: '180px',
        height: '180px',
        md: {
          width: '355px',
          height: '355px',
        },
      },
      smallProducts: {
        width: '180px',
        height: '180px',
        md: {
          width: '180px',
          height: '180px',
        },
      },
      kitchenQuizProducts: {
        width: '180px',
        height: '180px',
        md: {
          width: '180px',
          height: '180px',
        },
      },
    },
    sectionHeading: {
      fontFamily: 'Clan',
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '26px',
      md: {
        fontSize: '26px',
        lineHeight: '34px',
      },
    },
    product: {
      label: {
        color: '#999',
        fontWeight: 400,
        fontSize: '11px',
        lineHeight: '20px',
        letterSpacing: rem(1.7),
        textTransform: 'uppercase',
      },
      block: {
        padding: '5px',
      },
      margins: {
        small: rem(16),
        large: rem(50),
        md: {
          small: rem(40),
          large: rem(64),
        },
      },
      name: {
        color: textColor,
        fontSize: '14px',
        fontWeight: 700,
        lineHeight: '19px',
        md: {
          fontSize: '16px',
          lineHeight: '24px',
        },
        smallProduct: {
          color: '#999',
          fontWeight: 400,
          fontSize: '11px',
          lineHeight: '20px',
          letterSpacing: rem(1.7),
          textTransform: 'uppercase',
        },
      },
      kitchenQuiz: {
        itemParagraph: 700,
        description: 700,
      },
      description: {
        color: textColor,
        fontSize: '14px',
        fontWeight: 300,
        lineHeight: '19px',
        md: {
          fontSize: '16px',
          lineHeight: '24px',
        },
        smallProduct: {
          fontWeight: 700,
        },
      },
    },
  },
  appointment: {
    background: 'transparent',
    padding: '0',
    appointment: {
      heading: {
        fontSize: theme.rem(14),
        fontWeight: 700,
        lineHeight: theme.rem(19),
      },
      text: {
        fontSize: theme.rem(14),
        fontWeight: 300,
        lineHeight: theme.rem(19),
      },
      icon: {
        background: tone1,
        color: primaryColor,
      },
      hr: {
        color: '#e9e1d9',
      },
    },
    prepare: {
      heading: {
        fontSize: theme.rem(18),
        fontWeight: 700,
        lineHeight: theme.rem(20),
      },
      text: {
        fontSize: theme.rem(14),
        fontWeight: 300,
        lineHeight: theme.rem(19),
      },
    },
  },
  order: {
    background: white,
    border: `2px solid #cbd0d4`,
    borderRadius: rem(6),
    orderCancelled: {
      errorTextColor: '#e12e21',
    },
    selectItem: {
      paddingBottom: '20px',
      padding: '10px 20px',
      evenColor: white,
      unEvenColor: white,
    },
    label: {
      fontWeight: 300,
    },
  },
  step: {
    checkedStep: {
      border: `1px solid ${lineColor}`,
    },
    uncheckedStep: {
      border: `1px solid transparent`,
      background: tone1,
    },
    margins: '0 0 50px 0',
    borderRadius: '6px',
    checkline: {
      width: '1px',
      colors: {
        default: lineColor,
        checked: 'transparent',
      },
      position: {
        height: '75px',
        top: '-50px',
      },
    },
  },
  overlayBada: {
    icon: {
      background: primaryColor,
      color: white,
      top: '20px',
      md: {
        top: '35px',
      },
    },
  },
  checkbox: {
    color: primaryColor,
    background: tone1,
    uncheckedBackground: white,
    borderColor: white,
    size: 44,
    strokeWidth: 5,
    strokeSize: 0.9,
  },
  loadingIndicator: {
    color: secondaryColor,
  },
  help: {
    topBackground: tone2,
    background: tone2,
    borderRadius: rem(2),
    border: `${rem(1)} solid #ddd`,
    tabs: {
      color: textColor,
      indicatorColor: secondaryColor,
    },
  },
  spacings: {
    xxxs: 2,
    xxs: 4,
    xs: 8,
    s: 12,
    m: 16,
    l: 24,
    xl: 32,
    xxl: 64,
    xxxl: 96,
  },
  carousel: {
    border: `1px solid #fff`,
    borderRadius: rem(6),
    selector: {
      position: 'absolute',
      margin: '10px 0',
    },
  },
  multiStorePage: {
    background: white,
    alignItems: 'center',
    maxWidth: rem(849),
    storeSelector: {
      background: tone1,
      border: 'none',
      borderRadius: '3px',
    },
  },
  messages: {
    sendMessage: {
      background: white,
      borderColor: lineColor,
      button: {
        background: primaryColor,
        color: white,
      },
    },
    bubble: {
      store: tone3,
      customer: tone1,
      initials: {
        background: primaryColor,
      },
    },
    input: {
      borderColor: lineColor,
    },
    textarea: {
      borderColor: lineColor,
    },
    newMessages: {
      borderColor: lineColor,
      color: red,
    },
  },
}
